import { lazy, Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, Route, Routes } from "react-router-dom";
import BrowserDisclaimer from "shared/components/BrowserDisclaimer";
import { RELEASE_NOTES_URL } from "shared/constants";
import { PATHS } from "shared/constants/paths";
import Navbar from "shared/containers/Navbar";

const SSML = lazy(() => import("features/SSML"));
const TTSHomepage = lazy(() => import("features/TTS"));
const MarkdownRenderer = lazy(
  () => import("shared/containers/MarkdownRenderer")
);
const CheatSheet = lazy(() => import("../SSML/CheatSheet"));
const ThirdPartyNotices = lazy(() =>
  import("@web-applications/allinga-web-components").then((module) => ({
    default: module.ThirdPartyNotices,
  }))
);
const Copyright = lazy(() =>
  import("@web-applications/allinga-web-components").then((module) => ({
    default: module.Copyright,
  }))
);

const routeFallback = (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "40vh",
    }}
  >
    <CircularProgress />
  </Box>
);

export default function AppRoutesOnPrem(): JSX.Element {
  return (
    <>
      <Navbar />
      <BrowserDisclaimer />
      <Suspense fallback={routeFallback}>
        <Routes>
          <Route path={PATHS.root} element={<TTSHomepage />} />
          <Route
            path={PATHS.releaseNotes}
            element={<MarkdownRenderer url={RELEASE_NOTES_URL} />}
          />
          <Route path={PATHS.ssmlGuide} element={<SSML />} />
          <Route path={PATHS.ssmlCheatSheet} element={<CheatSheet />} />
          <Route
            path={PATHS.thirdPartyNotices}
            element={<ThirdPartyNotices />}
          />
          <Route path={PATHS.copyright} element={<Copyright />} />

          {/* Redirect any URL to root */}
          <Route path="*" element={<Navigate to={PATHS.root} />} />
        </Routes>
      </Suspense>
    </>
  );
}
